import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import connect from '../../utils/connect';
import {
    defaultPrimaryColor,
    defaultSecondaryColor,
} from '../../constants/colors';
import { MVC_REFRESH } from '../../constants/config';
import mixColors from '../../utils/mixColors';

const prctList = [5, 10, 15, 30, 50, 70];

const BLACK_COLOR_HEX = '#000000';
const WHITE_COLOR_HEX = '#ffffff';

function ThemeColorizer({
    primaryColor = null,
    secondaryColor = null,
    overridePrimary = null,
    overrideSecondary = null,
}) {
    useEffect(() => {
        const root = document.documentElement;

        const primary = overridePrimary || primaryColor || defaultPrimaryColor;
        const secondary =
            overrideSecondary || secondaryColor || defaultSecondaryColor;

        root.style.setProperty('--primary', primary);
        root.style.setProperty('--secondary', secondary);

        prctList.forEach(prct => {
            const lightPri = mixColors(WHITE_COLOR_HEX, primary, prct);
            const lightSec = mixColors(WHITE_COLOR_HEX, secondary, prct);
            const darkPri = mixColors(BLACK_COLOR_HEX, primary, prct);
            const darkSec = mixColors(BLACK_COLOR_HEX, secondary, prct);

            root.style.setProperty(`--primary-light-${prct}prct`, lightPri);
            root.style.setProperty(`--secondary-light-${prct}prct`, lightSec);
            root.style.setProperty(`--primary-dark-${prct}prct`, darkPri);
            root.style.setProperty(`--secondary-dark-${prct}prct`, darkSec);
        });
    }, [primaryColor, secondaryColor, overridePrimary, overrideSecondary]);

    return null;
}

ThemeColorizer.propTypes = {
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    overridePrimary: PropTypes.string,
    overrideSecondary: PropTypes.string,
};

const mapStateToProps = ({ user = {}, client = {} }) => {
    const { primaryColor, secondaryColor } = client;
    const hasMvcRefreshPermission = client.permissions?.includes(MVC_REFRESH);
    const storedValue = localStorage.getItem('show-mvc-refresh');
    const shouldOverrideColors = hasMvcRefreshPermission && storedValue === '1';

    let overridePrimary = null,
        overrideSecondary = null;

    if (user.overrides) {
        overridePrimary = user.overrides.primaryColor;
        overrideSecondary = user.overrides.secondaryColor;
    }

    if (shouldOverrideColors) {
        overridePrimary = '#A3BDC7';
        overrideSecondary = '#009FDF';
    }

    return {
        primaryColor,
        secondaryColor,
        overridePrimary,
        overrideSecondary,
    };
};

export default connect(mapStateToProps)(React.memo(ThemeColorizer));
